import React from 'react'
import { Message, Icon } from 'semantic-ui-react';

const ErrorMessage = (props) => (
    <Message
        size='tiny'
        negative
        icon={<Icon name="warning sign" className="f_18" />}
        header={props.errorHead}
        content={props.errorContent}
        className="f_11 clr-red"
    />
)

export default ErrorMessage